import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    FiChevronDown,
    FiClock,
    FiExternalLink,
    FiArrowUp,
    FiAward,
    FiStar
} from "react-icons/fi";
import { FaCrown } from "react-icons/fa";
import API_BASE_URL from "../config";
import "../styles/SubscriptionCountdown.css";

export default function SubscriptionCountdown() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [subscription, setSubscription] = useState(null);
    const [timeLeft, setTimeLeft] = useState("");
    const [isUpgraded, setIsUpgraded] = useState(false);

    /* ======================
       FETCH SUBSCRIPTION
    ====================== */
    useEffect(() => {
        const fetchSubscription = async () => {
            try {
                const token = sessionStorage.getItem("token");
                if (!token) return;

                const res = await fetch(
                    `${API_BASE_URL}/api/auth/subscription`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                const data = await res.json();

                if (res.ok && data.subscription) {
                    setSubscription(data.subscription);
                    setIsUpgraded(data.isUpgraded);
                }
            } catch (err) {
                console.error("Subscription fetch error:", err);
            }
        };

        fetchSubscription();
    }, []);

    /* ======================
       LIVE COUNTDOWN
    ====================== */
    useEffect(() => {
        if (!subscription?.endDate) return;

        const interval = setInterval(() => {
            const now = new Date();
            const end = new Date(subscription.endDate);
            const diff = end - now;

            if (diff <= 0) {
                setTimeLeft("Expired");
                clearInterval(interval);
                return;
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor(
                (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            const minutes = Math.floor(
                (diff % (1000 * 60 * 60)) / (1000 * 60)
            );
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
        }, 1000);

        return () => clearInterval(interval);
    }, [subscription]);

    if (!subscription) return null;

    return (
        <div className="subscription-countdown-wrapper">

            {/* ======================
         MAIN BADGE
      ====================== */}
            <div
                className="subscription-badge"
                onClick={() => setOpen(!open)}
            >
                <div className="sub-main-row">
                    <span className="sub-plan-name">
                        {subscription.planName}
                    </span>

                    <span
                        className={`sub-status ${subscription.subscriptionStatus.toLowerCase()}`}
                    >
                        {subscription.subscriptionStatus}
                    </span>

                    {!isUpgraded ? (
                        <span className="upgrade-tag">
                            Upgrade <FiArrowUp size={12} />
                        </span>
                    ) : (
                        <span className="upgraded-tag">
                            Upgraded ✓
                        </span>
                    )}
                </div>

                <FiChevronDown
                    size={16}
                    className={open ? "rotate" : ""}
                />
            </div>

            {/* ======================
         DROPDOWN
      ====================== */}
            {open && (
                <div className="subscription-dropdown">

                    {/* HEADER WITH BADGE ON RIGHT */}
                    <div className="dropdown-header">
                        <div className="header-top">
                            <h4>Your Subscription</h4>

                            <div className={`plan-tier-badge ${subscription.planName.toLowerCase()}`}>
                                {subscription.planName === "FREE" && (
                                    <>
                                        <FiAward size={14} />
                                        <span>Bronze</span>
                                    </>
                                )}

                                {subscription.planName === "PROFESSIONAL" && (
                                    <>
                                        <FiStar size={14} />
                                        <span>Silver</span>
                                    </>
                                )}

                                {subscription.planName === "ENTERPRISE" && (
                                    <>
                                        <FaCrown size={14} />
                                        <span>Gold</span>
                                    </>
                                )}
                            </div>
                        </div>

                        <p>ID: {subscription.subscriptionId}</p>
                    </div>

                    <div className="dropdown-row">
                        <span>Plan</span>
                        <strong>{subscription.planName}</strong>
                    </div>

                    <div className="dropdown-row">
                        <span>Type</span>
                        <strong>{subscription.planType}</strong>
                    </div>

                    <div className="dropdown-row">
                        <span>Status</span>
                        <strong>{subscription.subscriptionStatus}</strong>
                    </div>

                    <div className="dropdown-row countdown">
                        <FiClock size={14} />
                        <span>{timeLeft || "Calculating..."}</span>
                    </div>

                    <button
                        className="view-plan-btn"
                        onClick={() => navigate("/subscription")}
                    >
                        {isUpgraded ? "View Plan" : "Upgrade Now"}
                        <FiExternalLink size={14} />
                    </button>
                </div>
            )}
        </div>
    );
}